<template>
    <v-container class="my-5">
        <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
        <v-dialog v-model="dialogCellNumberWrong" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogCellNumberWrong = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo  Modal para Cambiar Permisos (Usuario -> Maestro)    -->
        <v-dialog v-model="dialogMoveUp" max-width="500">
            <v-form @submit.prevent="moveUpUserToTeacher()">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('move_up_user_to_teacher')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogMoveUp = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-autocomplete
                                    v-model="emailGuest"
                                    :items="items"
                                    prepend-icon="mdi-email"
                                    :loading="isLoading"
                                    :search-input.sync="search2"
                                    :item-text="exampleGuest"
                                    item-value="id"
                                    :placeholder="$t('placeholder_invitados2')"
                                    :label="$t('usuarios')"
                                    :error-messages="errores.idUser"
                                    :no-data-text="$t('no_resultados')"
                                    clearable
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            @click="data.select"
                                    >
                                        <v-avatar left>
                                            <v-img :src="data.item.avatar"></v-img>
                                        </v-avatar>
                                        {{ data.item.first_name }} {{data.item.last_name}}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-avatar>
                                            <img :src="data.item.avatar">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.first_name }} {{data.item.last_name}}</v-list-item-title>
                                            <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogMoveUp = false"
                        >
                            {{$t('cerrar')}}
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                                :loading="loading"
                                color="primary"
                                type="submit"
                        >
                            {{$t('modificar')}}
                            <v-icon dark right>mdi-swap-horizontal</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--    Diálogo  Modal para Asignar Aulas a Maestros   -->
        <v-dialog v-model="dialogSetClassroom" max-width="500">
            <v-form @submit.prevent="setClassroom()">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('set_classroom')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogSetClassroom = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-autocomplete
                                v-model="idTeacher"
                                prepend-icon="mdi-human-male-board"
                                :items="teachers"
                                :item-text="example"
                                :filter="customFilterTeacher"
                                item-value="id"
                                :placeholder="$t('placeholder_invitados2')"
                                :label="$t('teacher')"
                                :error-messages="errores.idTeacher"
                                :no-data-text="$t('no_resultados')"
                                clearable
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                        v-bind="data.attrs"
                                        :input-value="data.selected"
                                        @click="data.select"
                                >
                                    <v-avatar left>
                                        <v-img :src="data.item.idUser.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.idUser.first_name }} {{data.item.idUser.last_name}}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                    <v-list-item-avatar>
                                        <img :src="data.item.idUser.avatar">
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ data.item.idUser.first_name }} {{data.item.idUser.last_name}}</v-list-item-title>
                                        <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </template>
                        </v-autocomplete>
                        <v-autocomplete
                                v-model="idClassroom"
                                prepend-icon="mdi-google-classroom"
                                name="idClassroom"
                                :item-text="example2"
                                item-value="id"
                                :label="$t('classrooms')"
                                :filter="customFilterClassroom"
                                :items="classrooms"
                                :error-messages="errores.idClassroom"
                                :no-data-text="$t('no_resultados')"
                                clearable
                                autocomplete="off"
                        >
                            <template v-slot:item="data">
                                <strong>{{data.item.grade_name === null ? 'n/a' : data.item.grade_name}} {{data.item.name === null ? 'n/a' : data.item.name}}</strong>
                            </template>
                        </v-autocomplete>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogSetClassroom = false"
                        >
                            {{$t('cerrar')}}
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                                :loading="loading"
                                color="primary"
                                type="submit"
                        >
                            {{$t('set')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--    Diálogo  Modal para Mostrar Aulas asignadas al Maestro   -->
        <v-dialog v-model="dialogGetClassroom" scrollable max-width="300">
            <v-form>
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('assigned_classrooms')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogGetClassroom = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div v-if="classroomsXTeacher.length > 0">
                            <v-list two-line v-for="(classroomsByTeacher, i) in classroomsXTeacher" :key="i">
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title v-html="classroomsByTeacher.grade_name"></v-list-item-title>
                                  <v-list-item-subtitle v-html="classroomsByTeacher.name"></v-list-item-subtitle>
                                </v-list-item-content>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="red"
                                        class="mr-2"
                                        @click="deleteTeacherByGroup(classroomsByTeacher.idClassroom)"
                                    >
                                      mdi-close
                                    </v-icon>
                                  </template>
                                  <span>{{$t('delete')}}</span>
                                </v-tooltip>
                              </v-list-item>
                            </v-list>
                        </div>
                        <div v-else>
                            {{$t('no_classrooms')}}
                        </div>
                    </v-card-text>
                </v-card>
            </v-form>
        </v-dialog>
        <!--    Diálogo  Modal para Mostrar Horario del Maestro   -->
        <v-dialog v-model="dialogGetSchedule" scrollable max-width="800px">
            <v-form>
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('schedules')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogGetSchedule = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <v-row>
                        <v-col>
                          <v-sheet height="400">
                            <v-calendar
                                ref="calendar"
                                :locale="$t('region')"
                                :events="events"
                                color="primary"
                                type="week"
                                first-interval="5"
                                interval-count="20"
                                :hide-header="false"
                                :short-intervals="true"
                                :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                            ></v-calendar>
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </v-card-text>
                </v-card>
            </v-form>
        </v-dialog>
        <!--    Diálogo CRUD Horario del Maestro   -->
        <v-dialog v-model="dialogSetSchedule" scrollable max-width="500px">
            <v-form>
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('schedules')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogSetSchedule = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-textarea
                              v-model="extra_schedule_teacher"
                              outlined
                              placeholder="L 7:00-9:40, 10:30-12:00; M 8:30-11:00, 12:00-13:20; J 8:30-9:20, 10:30-12:00;"
                              :label="$t('extended_schedule')">
                          </v-textarea>
                        </v-col>
                      </v-row>
                      <v-data-table
                          v-model="selected"
                          :headers="headersDays"
                          :items="days"
                          :single-select="false"
                          item-key="id"
                          :show-select="true"
                          class="elevation-1"
                          hide-default-footer
                          :items-per-page="-1"
                      >
                        <template v-slot:item.action="{ item }">
                          <v-icon
                              v-if="validaUUID(item.id) === false"
                              medium
                              color="red"
                              class="mr-2"
                              @click="idScheduleDelete = item.id, deleteDialogSchedule = true"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <template v-slot:item.check_in_time="{ item }">
                          <v-text-field
                              v-model="item.check_in_time"
                              type="time"
                          ></v-text-field>
                        </template>
                        <template v-slot:item.check_out_time="{ item }">
                          <v-text-field
                              v-model="item.check_out_time"
                              type="time"
                          ></v-text-field>
                        </template>
                      </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="primary" @click="dialogSetSchedule = false">{{$t('cerrar')}}</v-btn>
                      <v-spacer/>
                      <v-btn color="primary" :loading="loading" @click="saveSchedule">{{$t('guardar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Guardias     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_teacher')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>

                    <v-btn
                            color="primary"
                            :loading="loading"
                            @click="deleteTeacher()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Horario     -->
        <v-dialog
                v-model="deleteDialogSchedule"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_schedule')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary"
                            @click="deleteDialogSchedule = false"
                    >
                        No
                    </v-btn>

                    <v-btn
                            color="primary"
                            :loading="loading"
                            @click="deleteTeacherSchedule()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
        <v-dialog v-model="dialogImageFront" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageFront"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingFront()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
        <v-dialog v-model="dialogImageBack" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageBack"
                            :src="imageBackURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingBack()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL"
                            ref="clipperImageProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('teachers') }}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-layout row wrap class="justify-center">
                        <v-btn
                                color="primary"
                                dark
                                v-on="on"
                                @click="update = false,
                                cleanFields()"> + {{ $t('add_teacher') }}
                        </v-btn>
                        <v-btn
                                arrow_upward
                                color="primary"
                                @click="dialogMoveUp = true, emailGuest = '', entries = [], errores = [] "
                        >
                            <v-icon dark left>mdi-swap-horizontal</v-icon>
                            {{$t('cambiar_permisos')}}
                        </v-btn>
                        <v-btn
                                color="primary"
                                @click="dialogSetClassroom = true, idTeacher = null, idClassroom = null, errores = [] "
                        >
                            <v-icon dark left>mdi-account-switch</v-icon>
                            {{$t('set_classroom')}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-form
                        @submit.prevent="update
                                        ? updateTeacher(id_update)
                                        : createTeacher()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('teachers') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-text-field
                                    autofocus
                                    v-model="first_name"
                                    prepend-icon="mdi-account"
                                    name="first_name"
                                    :label="$t('Nombre')"
                                    :error-messages="errores.first_name"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="last_name"
                                    prepend-icon="mdi-account-outline"
                                    name="last_name"
                                    :label="$t('Apellido')"
                                    :error-messages="errores.last_name"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="nss"
                                    prepend-icon="mdi-code-string"
                                    name="nss"
                                    :label="$t('nss')"
                                    type="number"
                                    :error-messages="errores4"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="employee_number"
                                    prepend-icon="mdi-numeric"
                                    name="employee_number"
                                    :label="$t('employee_number')"
                                    type="number"
                                    :error-messages="errores5"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="rfid"
                                    prepend-icon="mdi-tag"
                                    name="rfid"
                                    label="RFID"
                                    :error-messages="errores.access_code"
                            >
                            </v-text-field>
                            <v-spacer/>
                            <v-autocomplete
                                v-model="section"
                                outlined
                                :placeholder="$t('placeholder_choose_section')"
                                prepend-icon="mdi-account-details"
                                name="section"
                                item-text="name"
                                item-value="section"
                                :label="$t('section')"
                                :error-messages="errores3"
                                :items="sections"
                                no-data-text="Ningún Resultado"
                                clearable
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            @click="data.select"
                                    >
                                        {{ data.item.name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            <v-autocomplete
                                v-model="position"
                                outlined
                                :placeholder="$t('placeholder_choose_position')"
                                prepend-icon="mdi-sitemap"
                                name="position"
                                item-text="name"
                                item-value="position"
                                :label="$t('position')"
                                :error-messages="errores6"
                                :items="positions"
                                no-data-text="Ningún Resultado"
                                clearable
                            >
                              <template v-slot:selection="data">
                                <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    @click="data.select"
                                >
                                  {{ data.item.name }}
                                </v-chip>
                              </template>
                              <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                  <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content>
                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                            <v-checkbox
                                v-show="getProfile.role === 4"
                                class="ml-2"
                                v-model="teacher_attendance"
                                :label="$t('msg_view_history_all_personnel')"
                            ></v-checkbox>
                            <v-layout row wrap class="text-center">
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultFrontURL"
                                            v-if="resultFrontURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-alert
                                            v-if="errores.idFront"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.idFront}}
                                    </v-alert>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageFront = true, degrees = 0, ratio = '1'"
                                                accept="image/*"
                                                v-model="imageFrontURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('atras')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultBackURL"
                                            v-if="resultBackURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-alert
                                            v-if="errores.idBack"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.idBack}}
                                    </v-alert>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageBack = true, degrees = 0, ratio = '1'"
                                                accept="image/*"
                                                v-model="imageBackURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap class="text-center">
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_perfil')}}
                                    </v-label>
                                    <br>
                                    <v-avatar
                                            class="profile"
                                            color="grey"
                                            size="200"
                                    >
                                        <v-img :src="resultProfileURL"
                                               v-if="resultProfileURL"
                                        >
                                        </v-img>
                                    </v-avatar>
                                    <br>
                                    <v-alert
                                            v-if="errores.avatar"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.avatar}}
                                    </v-alert>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageProfile = true, degrees = 0, ratio = '1'"
                                                accept="image/*"
                                                v-model="imageProfileURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <vue-tel-input
                                    class="mt-3 mb-3"
                                    v-model="celular"
                                    @onInput="onInput"
                            >
                                <v-alert v-if="errores.cellNumber" type="error">{{errores.cellNumber}}</v-alert>
                            </vue-tel-input>
                            <v-alert outlined v-if="errores.cellNumber" type="error">{{errores.cellNumber}}</v-alert>
<!--                            <v-layout row wrap>-->
<!--                                <v-flex v-bind:class="(update) ? 'xs12 sm6 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'">-->
                                    <v-text-field
                                            v-model="email"
                                            prepend-icon="mdi-email"
                                            name="email"
                                            label="E-Mail"
                                            :error-messages="errores.email"
                                            autocomplete="username"
                                    >
                                    </v-text-field>
<!--                                </v-flex>-->
<!--                                <v-flex v-show="update" v-bind:class="(update) ? 'xs12 sm6 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'">-->
<!--                                    <v-checkbox-->
<!--                                            v-model="activa"-->
<!--                                            name="activa"-->
<!--                                            :label="$t('Activo')"-->
<!--                                            :error-messages="errores.activa"-->
<!--                                    ></v-checkbox>-->
<!--                                </v-flex>-->
<!--                            </v-layout>-->
                            <v-checkbox
                                    v-model="change_password"
                                    v-if="update" disable
                                    name="change_password"
                                    label="Cambiar Contraseña"
                            ></v-checkbox>
                            <ValidationObserver>
                                <ValidationProvider :rules="change_password ? 'required|password:@confirm' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            v-model="password"
                                            :disabled="update && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show"
                                            autocomplete="new-password"
                                            :error-messages="change_password ? errores.password : ''">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider name="confirm" :rules="change_password ? 'required' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            v-model="confirmation"
                                            :disabled="update  && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password_confirm')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            autocomplete="new-password"
                                            @click:append="show = !show">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </ValidationObserver>
                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    transition="scale-transition"
                            >
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="clear(),
                                    dialog = false"
                            >{{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    :loading="loading"
                                    v-if="update"
                                    color="primary"
                                    type="submit"
                            >{{$t('modificar')}}
                            </v-btn>
                            <v-btn
                                    :loading="loading"
                                    v-else
                                    color="primary"
                                    type="submit"
                            >{{$t('agregar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{$t('teachers')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-account-search"
                            :label="$t('Buscar')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loadingTeachers"
                        :items="teachers"
                        :search="search"
                        class="elevation-1"
                >
                    <template v-slot:items="props">
                        <td>{{ props.item.first_name }}</td>
                        <td>{{ props.item.last_name }}</td>
                        <td>{{ props.item.cellNumber }}</td>
                        <td>{{ props.item.email }}</td>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon
                                medium
                                color="grey"
                                class="mr-2"
                                @click="fillFields(item), update = true, dialog = true, id_update = item.id"
                        >
                            mdi-account-edit
                        </v-icon>
                        <v-icon
                                medium
                                color="red"
                                class="mr-2"
                                @click="idTeacherDelete = item.id, deleteDialog = true"
                        >
                            mdi-delete
                        </v-icon>
                        <v-icon
                                medium
                                color="primary"
                                class="mr-2"
                                @click="idTeacherDelete = item.id, fillScheduleTeacher()"
                        >
                            mdi-calendar-multiselect
                        </v-icon>
                        <v-icon
                                medium
                                color="green"
                                class="mr-2"
                                @click="idTeacherDelete = item.id, extra_schedule_teacher = item.extra_schedule, fillSchedule()"
                        >
                            mdi-calendar-plus
                        </v-icon>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="primary"
                                        @click="dialogGetClassroom = true, id_update = item.id, getClassroom(item.id)"
                                >
                                    mdi-google-classroom
                                </v-icon>
                            </template>
                            <span>{{$t('see_classrooms')}}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:no-results>
                        <v-alert type="warning">
                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                        </v-alert>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import {mapGetters, mapState} from 'vuex'
import Vue from 'vue'
import {required} from 'vee-validate/dist/rules'

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

extend('required', {
  ...required,
  message: 'This field is required'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'teachers',
  created () {
    this.getTeachers()
    this.getClassrooms()
  },
  data: () => ({
    show: false,
    alerta: false,
    dialog: false,
    update: false,
    id_update: 0,
    id_house: '',
    first_name: '',
    last_name: '',
    celular: '',
    email: '',
    email_aux: '',
    celular_aux: '',
    password: '',
    errores: [],
    errores2: [],
    errores3: [],
    errores4: [],
    errores5: [],
    errores6: [],
    headers: [],
    houses: [],
    teachers: [],
    activa: '',
    change_password: '',
    loadingTeachers: false,
    confirmation: '',
    search: '',
    // Imágenes
    dialogImageFront: false,
    dialogImageBack: false,
    dialogImageProfile: false,
    imageFrontURL: '',
    imageBackURL: '',
    imageProfileURL: '',
    resultFrontURL: '',
    resultBackURL: '',
    resultProfileURL: '',
    resultAuxFrontURL: '',
    resultAuxBackURL: '',
    resultAuxProfileURL: '',
    // Delete Guard
    deleteDialog: false,
    idTeacherDelete: 0,
    idScheduleDelete: 0,
    // Move Up
    dialogMoveUp: false,
    dialogSetClassroom: false,
    emailGuest: '',
    isLoading: false,
    search2: null,
    entries: [],
    band_cellphone: false,
    dialogCellNumberWrong: false,
    loading: false,
    idClassroom: null,
    classrooms: [],
    idTeacher: null,
    dialogGetClassroom: false,
    dialogGetSchedule: false,
    dialogSetSchedule: false,
    classroomsXTeacher: [],
    degrees: 0,
    ratio: '1',
    section:'',
    sections: [
      { header: 'Secciones'},
      { name: 'Kinder', section: 'kinder'},
      { name: 'Primaria', section: 'primaria'},
      { name: 'Secundaria', section: 'secundaria'},
      { name: 'Preparatoria', section: 'preparatoria'},
      { name: 'Administrativo', section: 'administrativo'},
      { name: 'Desconocido', section: 'desconocido'}
    ],
    position: '',
    positions: [
      { header: 'Puesto'},
      { name: 'General', section: 'General'},
      { name: 'Intendencia', section: 'Intendencia'},
      { name: 'Docente', section: 'Docente'},
      { name: 'Coordinador', section: 'Coordinador'},
      { name: 'Subdirector', section: 'Subdirector'},
      { name: 'Director', section: 'Director'},
      { name: 'Administrativo', section: 'Administrativo'},
      { name: 'Desconocido', section: 'Desconocido'}
    ],
    teacher_attendance: false,
    nss: '',
    employee_number: '',
    extra_schedule: '',
    rfid_aux: '',
    rfid: '',
    events: [],
    selected: [],
    headersDays: [],
    deleteDialogSchedule: false,
    extra_schedule_teacher: '',
    days: []
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'idUser.first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'idUser.last_name'
      },
      {
        text: this.$t('celular'),
        align: 'left',
        sortable: true,
        value: 'idUser.cellNumber'
      },
      {
        text: 'E-Mail',
        align: 'left',
        sortable: true,
        value: 'idUser.email'
      }
    ]
    this.headersDays = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: 'check',
        value: 'data-table-select'
      },
      {
        text: this.$t('day'),
        align: 'left',
        sortable: false,
        value: 'nameDay'
      },
      {
        text: this.$t('check_in_time'),
        align: 'left',
        sortable: false,
        value: 'check_in_time'
      },
      {
        text: this.$t('check_out_time'),
        align: 'left',
        sortable: false,
        value: 'check_out_time'
      }
    ]
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    fields () {
      if (!this.emailGuest) return []

      return Object.keys(this.emailGuest).map(key => {
        return {
          key,
          value: this.emailGuest[key] || 'n/a'
        }
      })
    },
    items () {
      return this.entries.map(entry => {
        const email = entry.email.length > this.descriptionLimit
          ? entry.email.slice(0, this.descriptionLimit) + '...'
          : entry.email

        return Object.assign({}, entry, { email })
      })
    }
  },
  watch: {
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    search2 (val) {
      if (val !== null & val !== undefined) {
        if (val.length > 2) {
          this.isLoading = true
          // Lazily load input items
          HTTP.get('guests/filter?search=' + val, {
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(response => {
            // console.log(response.data)
            if (this.entries.length > 0) {
              for (var i = 0; i < response.data.length; i++) {
                this.entries.push(response.data[i])
              }
            } else {
              this.entries = response.data
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => (this.isLoading = false))
        }
      }
    }
  },
  methods: {
    getClassrooms () {
      HTTP.get('classrooms/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.classrooms = response.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    fillSchedule () {
      HTTP.get('schedule/' + this.idTeacherDelete + '/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.selected = []
        this.refillSchedule(response.data)
        this.dialogSetSchedule = true
      })
      .catch(error => {
        console.log(error)
        if(error.request.status === 404) {
          this.selected = []
        }
      })
    },
    fillScheduleTeacher () {
      HTTP.get('schedule/' + this.idTeacherDelete + '/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.events = []
        this.refillScheduleTeacher(response.data)
        this.dialogGetSchedule = true
      })
      .catch(error => {
        console.log(error)
        if(error.request.status === 404) {
          this.events = []
        }
      })
    },
    refillScheduleTeacher (schedules) {
      let curr = new Date
      let uno = null
      let dos = null
      let tres = null
      let cuatro = null
      let cinco = null
      let seis = null
      let siete = null
      let check_in_time = ''
      let check_out_time = ''
      for (let i = 0; i < schedules.length; i++) {
         switch (schedules[i].day) {
           case '0':
             uno = new Date(curr.setUTCDate(curr.getUTCDate() - curr.getUTCDay()+1)).toISOString().split('T')[0]
             check_in_time = uno + ' ' +  schedules[i].check_in_time
             check_out_time = uno + ' ' +  schedules[i].check_out_time
             break;
           case '1':
             dos = new Date(curr.setUTCDate(curr.getUTCDate() - curr.getUTCDay()+2)).toISOString().split('T')[0]
             check_in_time = dos + ' ' +  schedules[i].check_in_time
             check_out_time = dos + ' ' +  schedules[i].check_out_time
             break;
           case '2':
             tres = new Date(curr.setUTCDate(curr.getUTCDate() - curr.getUTCDay()+3)).toISOString().split('T')[0]
             check_in_time = tres + ' ' +  schedules[i].check_in_time
             check_out_time = tres + ' ' +  schedules[i].check_out_time
             break;
           case '3':
             cuatro = new Date(curr.setUTCDate(curr.getUTCDate() - curr.getUTCDay()+4)).toISOString().split('T')[0]
             check_in_time = cuatro + ' ' +  schedules[i].check_in_time
             check_out_time = cuatro + ' ' +  schedules[i].check_out_time
             break;
           case '4':
             cinco = new Date(curr.setUTCDate(curr.getUTCDate() - curr.getUTCDay()+5)).toISOString().split('T')[0]
             check_in_time = cinco + ' ' +  schedules[i].check_in_time
             check_out_time = cinco + ' ' +  schedules[i].check_out_time
             break;
           case '5':
             seis = new Date(curr.setUTCDate(curr.getUTCDate() - curr.getUTCDay()+6)).toISOString().split('T')[0]
             check_in_time = seis + ' ' +  schedules[i].check_in_time
             check_out_time = seis + ' ' +  schedules[i].check_out_time
             break;
           case '6':
             siete = new Date(curr.setUTCDate(curr.getUTCDate() - curr.getUTCDay()+7)).toISOString().split('T')[0]
             check_in_time = siete + ' ' +  schedules[i].check_in_time
             check_out_time = siete + ' ' +  schedules[i].check_out_time
             break;
         }
         // console.log('check_in_time = ', check_in_time)
         // console.log('check_out_time = ', check_out_time)
         let aux = {}
         aux ['name'] = 'Horario'
         aux ['start'] = check_in_time
         aux ['end'] = check_out_time
         this.events.push(aux)
       }
    },
    refillSchedule (schedules) {
      this.days = []
      console.log('DIAS = ', this.days)
      let day = ''
      for (let i = 0; i < schedules.length; i++) {
        switch (schedules[i].day) {
          case '0':
            day = this.$t('Lunes')
          break;
          case '1':
            day = this.$t('Martes')
          break;
          case '2':
            day = this.$t('Miercoles')
          break;
          case '3':
            day = this.$t('Jueves')
          break;
          case '4':
            day = this.$t('Viernes')
          break;
          case '5':
            day = this.$t('Sabado')
          break;
          case '6':
            day = this.$t('Domingo')
          break;
        }
        let aux = {}

        aux ['id'] = schedules[i].id
        aux ['day'] = schedules[i].day
        aux ['nameDay'] = day
        aux ['check_in_time'] = schedules[i].check_in_time
        aux ['check_out_time'] = schedules[i].check_out_time
        this.selected.push(aux)
      }
      // Copiamos el contenido del arreglo selected al arreglo days
      for (let i = 0; i < this.selected.length; i++) {
        this.days.push(this.selected[i])
      }
      if (this.days.length !== 0) {
        let dias = ''
        for(let i = 0; i < this.days.length; i++) {
          dias += this.days[i].day
        }
        let aux = {}
        console.log('Dias = ', dias)
        if (dias.includes('0') === false) {
          aux = {}
          aux ['id'] = 0
          aux ['day'] = '0'
          aux ['nameDay'] = this.$t('Lunes'),
          aux ['check_in_time'] = '07:00',
          aux ['check_out_time'] =  '12:00'
          this.days.push(aux)
        }
        if (dias.includes('1') === false) {
          aux = {}
          aux ['id'] = 1
          aux ['day'] = '1'
          aux ['nameDay'] = this.$t('Martes'),
          aux ['check_in_time'] = '07:00',
          aux ['check_out_time'] =  '12:00'
          this.days.push(aux)
        }
        if (dias.includes('2') === false) {
          aux = {}
          aux ['id'] = 2
          aux ['day'] = '2',
          aux ['nameDay'] = this.$t('Miercoles'),
          aux ['check_in_time'] = '07:00',
          aux ['check_out_time'] =  '12:00'
          this.days.push(aux)
        }
        if (dias.includes('3') === false) {
          aux = {}
          aux ['id'] = 3
          aux ['day'] = '3',
          aux ['nameDay'] = this.$t('Jueves'),
          aux ['check_in_time'] = '07:00',
          aux ['check_out_time'] =  '12:00'
          this.days.push(aux)
        }
        if (dias.includes('4') === false) {
          aux = {}
          aux ['id'] = 4
          aux ['day'] ='4',
          aux ['nameDay'] = this.$t('Viernes'),
          aux ['check_in_time'] = '07:00',
          aux ['check_out_time'] =  '12:00'
          this.days.push(aux)
        }
        if (dias.includes('5') === false) {
          aux = {}
          aux ['id'] = 5
          aux ['day'] = '5',
          aux ['nameDay'] = this.$t('Sabado'),
          aux ['check_in_time'] = '07:00',
          aux ['check_out_time'] =  '12:00'
          this.days.push(aux)
        }
        if (dias.includes('6') === false) {
          aux = {}
          aux ['id'] = 6
          aux ['day'] = '6',
          aux ['nameDay'] = this.$t('Domingo'),
          aux ['check_in_time'] = '07:00',
          aux ['check_out_time'] =  '12:00'
          this.days.push(aux)
        }
      } else {
        this.days = [
          {
            id: 0,
            day: '0',
            nameDay: this.$t('Lunes'),
            check_in_time: '07:00',
            check_out_time: '12:00'
          },
          {
            id: 1,
            day: '1',
            nameDay: this.$t('Martes'),
            check_in_time: '07:00',
            check_out_time: '12:00'
          },
          {
            id: 2,
            day: '2',
            nameDay: this.$t('Miercoles'),
            check_in_time: '07:00',
            check_out_time: '12:00'
          },
          {
            id: 3,
            day: '3',
            nameDay: this.$t('Jueves'),
            check_in_time: '07:00',
            check_out_time: '12:00'
          },
          {
            id: 4,
            day: '4',
            nameDay: this.$t('Viernes'),
            check_in_time: '07:00',
            check_out_time: '12:00'
          },
          {
            id: 5,
            day: '5',
            nameDay: this.$t('Sabado'),
            check_in_time: '07:00',
            check_out_time: '12:00'
          },
          {
            id: 6,
            day: '6',
            nameDay: this.$t('Domingo'),
            check_in_time: '07:00',
            check_out_time: '12:00'
          }
        ]
      }
      this.days.sort(function (a, b) {
        if (a.day > b.day) {
          return 1;
        }
        if (a.day < b.day) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
    },
    getTeachers () {
      this.loadingTeachers = true
      HTTP.get('teacher/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.teachers = response.data
        this.loadingTeachers = false
      })
      .catch(error => {
        console.log(error)
        this.loadingTeachers = false
        // console.log(error)
      })
    },
    createTeacher () {
      if (this.band_cellphone === true) {
        this.loading = true
        this.errores = []
        this.errores2 = []
        this.errores3 = []
        this.errores4 = []
        this.errores5 = []
        this.errores6 = []
        if (this.section === undefined || this.section === '') {
          this.section = null
        }
        if (this.position === undefined || this.position === '') {
          this.position = null
        }
        var bodyFormData = new FormData()
        if (this.idClassroom === undefined) {
          this.idClassroom = null
        }
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        bodyFormData.set('idClassroom', this.idClassroom)
        bodyFormData.set('idUser.first_name', this.first_name)
        bodyFormData.set('idUser.last_name', this.last_name)
        bodyFormData.set('teacher_attendance', this.teacher_attendance)
        bodyFormData.set('nss', this.nss)
        bodyFormData.set('employee_number', this.employee_number)
        bodyFormData.set('idUser.access_code', this.rfid)
        bodyFormData.set('section', this.section)
        bodyFormData.set('position', this.position)
        bodyFormData.set('idUser.cellNumber', this.celular)
        bodyFormData.set('idUser.email', this.email.toLowerCase())
        bodyFormData.set('idUser.password', this.password)
        if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front.jpeg')
        }
        bodyFormData.append('idUser.idFront', fileImageFront)
        if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
          fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back.jpeg')
        }
        bodyFormData.append('idUser.idBack', fileImageBack)
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar.jpeg')
        }
        bodyFormData.append('idUser.avatar', fileImageProfile)
        HTTP.post('teacher/', bodyFormData, {
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        .then(ok => {
          this.loading = false
          console.log(ok)
          this.getTeachers()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_teacher_add'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data.idUser) {
              this.errores = error.response.data.idUser
            }
            if (error.response.data.idClassroom) {
              this.errores2 = error.response.data.idClassroom
            }
            if (error.response.data.section) {
              this.errores3 = error.response.data.section
            }
            if (error.response.data.position) {
              this.errores6 = error.response.data.position
            }
            if (error.response.data.nss) {
              this.errores4 = error.response.data.nss
            }
            if (error.response.data.employee_number) {
              this.errores5 = error.response.data.employee_number
            }
          }
        })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    updateTeacher (id) {
      if (this.band_cellphone === true) {
        this.loading = true
        this.errores = []
        this.errores2 = []
        this.errores3 = []
        this.errores4 = []
        this.errores5 = []
        this.errores6 = []
        if (this.section === undefined || this.section === '') {
          this.section = null
        }
        if (this.position === undefined || this.position === '') {
          this.position = null
        }
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        // Evitar Campo Fraccionamiento vacío
        if (this.idClassroom === undefined) {
          this.idClassroom = null
        }
        bodyFormData.set('idClassroom', this.idClassroom)
        if (this.email_aux !== this.email) {
          // idUser['email'] = this.email.toLowerCase()
          bodyFormData.set('idUser.email', this.email.toLowerCase())
        }
        if (this.rfid_aux !== this.rfid) {
          bodyFormData.set('idUser.access_code', this.rfid)
        }
        if (this.celular_aux !== this.celular) {
          bodyFormData.set('idUser.cellNumber', this.celular)
          // idUser['cellNumber'] = this.celular
        }
        if (this.change_password === true) {
          bodyFormData.set('idUser.password', this.password)
          // idUser['password'] = this.password
        }
        if (this.resultFrontURL !== this.resultAuxFrontURL) {
          const newID = this.$uuid.v4()
          if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
            fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.idFront', fileImageFront)
        }
        if (this.resultBackURL !== this.resultAuxBackURL) {
          const newID = this.$uuid.v4()
          if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
            fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.idBack', fileImageBack)
        }
        if (this.resultProfileURL !== this.resultAuxProfileURL) {
          const newID = this.$uuid.v4()
          if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
            fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.avatar', fileImageProfile)
        }
        bodyFormData.set('idUser.first_name', this.first_name)
        bodyFormData.set('idUser.last_name', this.last_name)
        console.log('Valor de = ', this.teacher_attendance)
        bodyFormData.set('teacher_attendance', this.teacher_attendance)
        console.log('Valor de NSS = ', this.nss)
        bodyFormData.set('nss', this.nss)
        console.log('Valor de employee_number = ', this.employee_number)
        bodyFormData.set('employee_number', this.employee_number)
        bodyFormData.set('section', this.section)
        bodyFormData.set('position', this.position)
        bodyFormData.set('extra_schedule', this.extra_schedule)
        HTTP.patch('teacher/' + id, bodyFormData, {
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        .then(ok => {
          this.loading = false
          console.log(ok)
          this.getTeachers()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_teacher_update'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          // console.log(error.response.data)
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data.idUser) {
              this.errores = error.response.data.idUser
            }
            if (error.response.data.idClassroom) {
              this.errores2 = error.response.data.idClassroom
            }
            if (error.response.data.section) {
              this.errores3 = error.response.data.section
            }
            if (error.response.data.position) {
              this.errores6 = error.response.data.position
            }
            if (error.response.data.nss) {
              this.errores4 = error.response.data.nss
            }
            if (error.response.data.employee_number) {
              this.errores5 = error.response.data.employee_number
            }
          }
        })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    deleteTeacher () {
      this.loading = true
      HTTP.delete('teacher/' + this.idTeacherDelete, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.loading = false
        // console.log('Guard con ID = ', this.idTeacherDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_teacher_delete'))
        this.getTeachers()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    deleteTeacherSchedule () {
      this.loading = true
      HTTP.delete('schedule/' + this.idTeacherDelete + '/schedule_by_teacher/' + this.idScheduleDelete, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('schedule_deleted'))
        this.fillSchedule()
        this.loading = false
        this.deleteDialogSchedule = false
        setTimeout(this.clear, 3000)
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    moveUpUserToTeacher () {
      this.loading = true
      this.errores = []
      HTTP.patch('teacher/make_from_guest/', {
        idUser: this.emailGuest
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        this.loading = false
        console.log(ok)
        this.getTeachers()
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('msg_cambio_permisos'))
        this.dialogMoveUp = false
        setTimeout(this.clear, 3000)
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    setClassroom () {
      this. errores = []
      this.loading = true
      if (this.idTeacher === undefined) {
          this.idTeacher = null
      }
      HTTP.post('teacher/' + this.idTeacher +'/classroom/', {
        idClassroom: this.idClassroom
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        this.loading = false
        console.log(ok)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('set_classroom_add'))
        this.dialogSetClassroom = false
        setTimeout(this.clear, 3000)
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
          if (error.response.data.non_field_errors)
            this.errores.idClassroom = error.response.data.non_field_errors
        }
      })
    },
    getOnlyIdClassrooms(data) {
      let res = []

      if (data.length !== 0) {
        for (let i = 0; i < data.length; i++) {
            res.push(data[i].idClassroom)
        }
        this.classroomsXTeacher = res
      } else {
          this.classroomsXTeacher = []
      }
    },
    getClassroom (idTeacher) {
      this.classroomsXTeacher = []
      HTTP.get('teacher/' + idTeacher + '/classroom/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.classroomsXTeacher = response.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    clear () {
      this.alerta = false
      this.errores = []
      this.errores2 = []
      this.errores3 = []
      this.errores4 = []
      this.errores5 = []
      this.errores6 = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    example2: item => (item.grade_name === null ? 'n/a' : item.grade_name) + ' ' + (item.name === null ? 'n/a' : item.name),
    customFilterClassroom (item, queryText) {
      var text = ''
      if (item.grade_name === null || item.grade_name === '') {
        text = 'n/a'
      } else {
        text = item.grade_name.toLowerCase()
      }
      if (item.name === null || item.name === '') {
        text += ' n/a'
      } else {
        text +=  ' ' +  item.name.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    fillFields (item) {
      this.idClassroom = item.idClassroom
      this.first_name = item.idUser.first_name
      this.last_name = item.idUser.last_name
      this.teacher_attendance = item.teacher_attendance
      if (item.nss === null)
        this.nss = ''
      else
        this.nss = item.nss
      if (item.employee_number === null)
        this.employee_number = ''
      else
        this.employee_number = item.employee_number
      if (item.idUser.access_code === null) {
        this.rfid_aux = ''
        this.rfid = ''
      }
      else {
        this.rfid_aux = item.idUser.access_code
        this.rfid = item.idUser.access_code
      }
      this.section = item.section
      this.position = item.position
      if (item.extra_schedule === null)
        this.extra_schedule = ''
      else
        this.extra_schedule = item.extra_schedule
      this.celular = item.idUser.cellNumber
      this.email = item.idUser.email
      this.email_aux = item.idUser.email
      this.celular_aux = item.idUser.cellNumber
      this.password = ''
      this.confirmation = ''
      this.change_password = false
      this.activa = item.idUser.is_active
      this.resultFrontURL = item.idUser.idFront
      this.resultBackURL = item.idUser.idBack
      this.resultProfileURL = item.idUser.avatar
      this.resultAuxFrontURL = item.idUser.idFront
      this.resultAuxBackURL = item.idUser.idBack
      this.resultAuxProfileURL = item.idUser.avatar
      this.band_cellphone = true
    },
    customFilter (item, queryText) {
      const textOne = item.street.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    cleanFields () {
      this.idClassroom = null
      this.id_house = ''
      this.first_name = ''
      this.last_name = ''
      this.teacher_attendance = false
      this.nss = ''
      this.employee_number = ''
      this.extra_schedule = ''
      this.rfid = ''
      this.rfid_aux = ''
      this.section = ''
      this.position = ''
      this.celular = ''
      this.email = ''
      this.email_aux = ''
      this.celular_aux = ''
      this.password = ''
      this.confirmation = ''
      this.change_password = true
      this.resultFrontURL = ''
      this.resultBackURL = ''
      this.resultProfileURL = ''
    },
    getCutingFront () {
      // console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageFront.clip() // call component's clip method
      this.resultFrontURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      this.dialogImageFront = false
      this.dialog = true
    },
    getCutingBack () {
      const canvas = this.$refs.clipperImageBack.clip() // call component's clip method
      this.resultBackURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      this.dialogImageBack = false
      this.dialog = true
    },
    getCutingProfile () {
      const canvas = this.$refs.clipperImageProfile.clip() // call component's clip method
      this.resultProfileURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      this.dialogImageProfile = false
      this.dialog = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onInput ({ number, isValid }) {
      this.celular = number.e164
      this.band_cellphone = isValid
    },
    example: item => (item.idUser.first_name === null ? 'n/a' : item.idUser.first_name) + ' ' + (item.idUser.last_name === null ? 'n/a' : item.idUser.last_name),
    exampleGuest: item => (item.first_name === null ? 'n/a' : item.first_name) + ' ' + (item.last_name === null ? 'n/a' : item.last_name),
    customFilterTeacher(item, queryText) {
      const textOne = item.idUser.first_name.toLowerCase()
      const textTwo = item.idUser.last_name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
    },
    deleteTeacherByGroup (idClassroom) {
      HTTP.delete('teacher/' + this.id_update + '/classroom/' + idClassroom, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.getClassroom(this.id_update)
      })
      .catch(error => {
        console.log(error)
      })
    },
    saveSchedule () {
      console.log('Seleccionados = ', this.selected)
      let horarios = []
      for(let i = 0 ; i < this.selected.length ; i++) {
        let aux = {}
        aux ['idTeacher'] = this.idTeacherDelete
        aux ['day'] = this.selected[i].day
        aux ['check_in_time'] = this.selected[i].check_in_time
        aux ['check_out_time'] = this.selected[i].check_out_time
        horarios.push(aux)
      }
      this.loading = true
      HTTP.post('schedule_by_teacher/',
            horarios,
          {
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            this.loading = false
            console.log(ok)
            this.$store.commit('snackbar_activate_true')
            this.updateExtraSchedule()
            this.dialogSetSchedule = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
          })
    },
    validaUUID (aUUID) {
      let res = false
      switch (aUUID){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
          res = true
        break
        default:
          res = false
      }
      return res
    },
    updateExtraSchedule () {
      this.errores = []
      HTTP.patch('teacher/' +  this.idTeacherDelete,
          {
            extra_schedule: this.extra_schedule_teacher
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('schedule_saved'))
            this.getTeachers()
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #00A1E4 #00A1E4 #00A1E4 #00A1E4;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
</style>
